import { fetch } from 'http-common';

export type TicketPriority = 'Low' | 'Normal' | 'High' | 'Critical';

export type ScreenshotItem = {
  screenshot: string;
  screenshotContentType: string;
};

export type CreateSupportTicketPayload = {
  subject: string;
  description: string;
  priority?: TicketPriority;
  // Decision 14: screenshots go inline, base64-encoded, in this same
  // request — no separate upload-URL/PUT round trip. Decision 16: up to 5
  // of them, as an array — colmar-be-nestjs's DTO no longer accepts the
  // old single screenshot/screenshotContentType scalar pair.
  screenshots?: ScreenshotItem[];
};

type CreateSupportTicketResponse = {
  success: boolean;
};

class SupportTicketDataService {
  private http = fetch();

  private ep = '/v1/support-tickets';

  public async submitTicket(payload: CreateSupportTicketPayload) {
    return this.http.post<CreateSupportTicketResponse>(this.ep, payload);
  }
}

const supportTicketDataService = new SupportTicketDataService();

export { supportTicketDataService };
